var JobSalary = /** @class */ (function () {
    function JobSalary() {
        this.maxSalary = 0;
        this.minSalary = 0;
        this.salaryType = null;
        this.salaryDuration = "PER_MONTH";
        this.currency = null;
    }
    return JobSalary;
}());
export { JobSalary };
//# sourceMappingURL=jobSalary.js.map